export default __webpack_public_path__ + "static/media/iconInfoDisabled48.472da51a.svg";